import cxs from 'cxs';
import { FONT_WEIGHTS } from '../../../common/styles/vars';

export default cxs({
  alignItems: 'center',
  background: '#D4D9E2',
  color: '#323A45',
  display: 'flex',
  fontSize: '30px',
  fontWeight: FONT_WEIGHTS.medium,
  justifyContent: 'center'
});